/**
 * Nexus Imports
 */
import { FC, SetStateAction, Dispatch } from 'react';
import { useDispatch } from 'react-redux';

/**
 * Nexus Imports
 */
import { NeuNavVertical } from '@neutron/react';

/**
 * Internal Imports
 */
import { setAdminUserTab } from '../../../../redux/actions';

/**
 * Style Imports
 */
import { SideNavLabel } from '../../SideNav.styles';
import ValidationUserListSideNavSection from './validationUserListSideNav/validationSideNavSection/ValidationSideNavSection';

interface SideNavProps {
  selectedTab: string;
  setSelectedTab: Dispatch<SetStateAction<string>>;
}

const SideNav: FC<SideNavProps> = ({ selectedTab, setSelectedTab }) => {
  const dispatch = useDispatch();
  const changeTab = (tab: string) => {
    dispatch(setAdminUserTab(tab));
    setSelectedTab(tab);
  };

  return (
    <NeuNavVertical
      id="Admin-Side-Nav"
      className="h-auto"
      kind="outlined"
      label="MENU"
      menu="blue"
      mode="drawer"
      style={{
        boxShadow: 'rgba(0, 0, 0, 0.15) 0 2px 4px',
        '--nav-width-drawer': 'clamp(200px, 25vw, 200px)'
      }}
    >
      <NeuNavVertical
        unit="header"
        style={{
          padding:
            '0 calc(var(--nav-padding-x) / 1.5) calc(var(--nav-padding-y) / 0.75)'
        }}
      />
      <NeuNavVertical unit="content">
        <NeuNavVertical
          id="Admin-Side-Nav-All"
          active={selectedTab === 'allUsers'}
          unit="item"
          onClick={() => changeTab('allUsers')}
        >
          <SideNavLabel>All Users</SideNavLabel>
        </NeuNavVertical>
        <NeuNavVertical
          id="Admin-Side-Nav-Patient-Rounders"
          active={selectedTab === 'patientRounder'}
          unit="item"
          onClick={() => changeTab('patientRounder')}
        >
          <SideNavLabel>Patient Rounders</SideNavLabel>
        </NeuNavVertical>
        <NeuNavVertical
          id="Admin-Side-Nav-Employee-Rounders"
          active={selectedTab === 'employeeRounder'}
          unit="item"
          onClick={() => changeTab('employeeRounder')}
        >
          <SideNavLabel>Employee Rounders </SideNavLabel>
        </NeuNavVertical>
        <ValidationUserListSideNavSection
          selectedTab={selectedTab}
          changeTab={changeTab}
        />
        <NeuNavVertical
          id="Admin-Side-Nav-CSC-Rounders"
          active={selectedTab === 'csrnRounder'}
          unit="item"
          onClick={() => changeTab('csrnRounder')}
        >
          <SideNavLabel>CSC Rounders</SideNavLabel>
        </NeuNavVertical>
        <NeuNavVertical
          id="Admin-Side-Nav-CNEd-Rounders"
          active={selectedTab === 'cnedRounder'}
          unit="item"
          onClick={() => changeTab('cnedRounder')}
        >
          <SideNavLabel>CNEd Rounders</SideNavLabel>
        </NeuNavVertical>
        <NeuNavVertical
          id="Admin-Side-Nav-Configurators"
          active={selectedTab === 'templateConfigurator'}
          unit="item"
          onClick={() => changeTab('templateConfigurator')}
        >
          <SideNavLabel>Configurators</SideNavLabel>
        </NeuNavVertical>
        <NeuNavVertical
          id="Admin-Side-Nav-User-Admins"
          active={selectedTab === 'userAdmin'}
          unit="item"
          onClick={() => changeTab('userAdmin')}
        >
          <SideNavLabel>User Admins</SideNavLabel>
        </NeuNavVertical>
        <NeuNavVertical
          id="Admin-Side-Nav-Enterprise"
          active={selectedTab === 'enterpriseAdmin'}
          unit="item"
          onClick={() => changeTab('enterpriseAdmin')}
        >
          <SideNavLabel>Enterprise Admins</SideNavLabel>
        </NeuNavVertical>
      </NeuNavVertical>
    </NeuNavVertical>
  );
};

export default SideNav;
